import React from 'react';

const eventSchedule = '/images/LavsWritingRetreats.png';

export default function Events() {
    return (
        <section id="events">
            <div className="events-header">
                <h1>Events</h1>
            </div>
            <div className="events-body">
                <div className="events-content">
                    <h2>Lav's Writing Retreat Events</h2>
                    <p>I am hosting a back to school themed writing retreat on <a
                        href='https://www.tumblr.com/blog/lavs-writing-room'>Lav's Writing
                        Room Tumblr.</a>
                        Join us however you would like. We would love to cheer you on!</p>

                    <h3>Sept Writing Retreat | Sept 23 - Sept 27</h3>
                    <p> Grab your tools and start creating! Tell us about it!</p>

                    <p><b><a href='https://www.tumblr.com/blog/lavs-writing-room'>On Tumblr every day there will a discussion post.</a></b></p>

                    <p>Use it to tell us what you are working on and how it is progressing! Reblog or comment and we will cheer you on. </p>
                    <p><a
                        href='https://www.tumblr.com/lavs-writing-room/826680509609426944/lavs-writing-retreat-sept-23-sept-27-2026'>Click
                        here to learn more.</a></p>

                </div>
                <img alt='event schedule' className={'event-schedule'} src={eventSchedule}/>
            </div>
        </section>
    )
}